import Task from "./Task";
import TaskExecutor from "./TaskExecutor";

export default class ITaskFactory {


    /**
     * Instantiates a Task subclass and injects dependencies
     * @param {Function} className - Class to instantiate must extend Task (or implement same methods).
     * @returns {Task} - instantiated task
     */
    instantiateTask(className) {
        return null;
    }
}